import React, { useState } from "react";
import { Button } from "antd";
import type { ReviewItem } from "../types";

type ReviewCardProps = {
  review: ReviewItem;
};

const ReviewCard: React.FC<ReviewCardProps> = ({ review }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <article className="review-card">
      <div className="review-card-top">
        <div>
          <h3 className="review-card-title">{review.shortComment}</h3>
          <p className="review-card-meta">
            {review.buyerName} | {review.vendorName}
          </p>
        </div>
        <span className={`review-rating ${review.rating <= 2 ? "is-flagged" : ""}`}>
          {review.rating}/5
        </span>
      </div>

      <div className="review-card-order">Order ID: {review.orderId}</div>

      {expanded && <p className="review-card-full">{review.fullComment}</p>}

      <Button
        type="link"
        className="review-view-more"
        onClick={() => setExpanded((current) => !current)}
      >
        {expanded ? "View Less" : "View More"}
      </Button>
    </article>
  );
};

export default ReviewCard;
